import React, { Tooltip } from "react-bootstrap"
import uuid from "react-uuid"
import WebWorker from "./PositiveResponseWebWorkerSetup"
import PositiveResponseStateWebWorker from "./PositiveResponseStateWebWorker"
import mutate from "./mutate"

const PositiveResponseService = {
    webWorker: new WebWorker(PositiveResponseStateWebWorker),
    state: {
        badTicketPositiveResponses: [],
        firstLoad: true,
        // busyId: 32706507
        busyId: -1,
        allChecked: false
    },
    refresh: () => {
        PositiveResponseService.manageState([
            { key: "badTicketPositiveResponses", value: [] },
            { key: "firstLoad", value: true },
            { key: "busyId", value: -1 },
            { key: "allChecked", value: false }
        ])
    },
    manageState: (keys: Array<{ key: string, value?: any }>) => {
        //@ts-ignore
        PositiveResponseService.webWorker.postMessage({ action: "updatePositiveResponseState", payload: mutate(PositiveResponseService.state, keys) })
    },
    positiveResponseTootlip: (text: string) => {
        return (
            <Tooltip id={uuid()}>
                {text}
            </Tooltip>
        )
    }
}

export default PositiveResponseService